import { DataPolicyColumnEffect } from '@vendia/management-api-types'
import { Table } from 'src/types/types'
import { LakehouseTableForm } from 'src/utils/lakehouse/types'

import { ProductColumnPolicies } from './product-column-policies'
import { ProductRowPolicies } from './product-row-policies'

export const ProductPolicies = ({ table, canEdit }: { table: Table | LakehouseTableForm; canEdit?: boolean }) => {
  const policies =
    'policies' in table
      ? table.policies
      : {
          defaultColumnPolicyEffect: table.defaultColumnPolicyEffect,
          columnPolicies: table.columnPolicies,
          rowPolicies: table.rowPolicies,
        }
  const excludeAll = policies.defaultColumnPolicyEffect === DataPolicyColumnEffect.Exclude
  const allowAll = policies.defaultColumnPolicyEffect === DataPolicyColumnEffect.Allow

  return (
    <div className='space-y-6 bg-slate-50 p-6 text-sm'>
      {/* One day maybe we can edit */}
      {/* {canEdit && (
        <Button
          kind='icon'
          size='small'
          icon='pencil'
          label='Update data products'
          onClick={() => navigate('../data/edit-tables')}
          disabled={!isLakehouseReady}
        />
      )} */}
      <div>
        <h6 className='h6 mb-2'>Column filters:</h6>
        <div className='divide-y rounded-md bg-white shadow ring ring-1 ring-slate-200 [&>*]:px-4 [&>*]:py-3'>
          <ProductColumnPolicies
            allowAll={allowAll}
            excludeAll={excludeAll}
            defaultColumnPolicyEffect={policies.defaultColumnPolicyEffect}
            columnPolicies={policies.columnPolicies || []}
          />
        </div>
      </div>
      <div>
        <h6 className='h6 mb-2'>Row filters:</h6>
        <div className='divide-y rounded-md bg-white shadow ring ring-1 ring-slate-200 [&>*]:px-4 [&>*]:py-3'>
          <ProductRowPolicies rowPolicies={policies.rowPolicies} />
        </div>
      </div>
    </div>
  )
}
